import { useContext } from 'react'
import { ScrollControlContext } from '@contexts/ScrollControlContext'

export function useScrollControl() {
  const { isScrollingContent, setIsScrollingContent } =
    useContext(ScrollControlContext)

  return { isScrollingContent, setIsScrollingContent }
}
